import styled from "styled-components";

const ViewPageWrapper = styled.div`
   display: flex;
   gap: 24px;
   flex-direction: column;
   width: 100%;
   height: 100%;
   padding-left: 16px;
   padding-right: 16px;

    @media (min-width: 600px) { /* S - Tablet */
        padding-left: 24px;
        padding-right: 24px;
    }

    @media (min-width: 1440px) { /* L - Default Laptop */
        padding-left: 32px;
        padding-right: 32px;
    }

    @media (min-width: 1920px) { /* XL - Widescreen */
        padding-left: 80px;
        padding-right: 80px;
    }

`
const PlaygroundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: calc(100vh - 48px);
  overflow: hidden;  
`;

const HeaderContainer = styled.div`
  gap: 24px;
  display: flex;
  flex-direction: column;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  min-height: 0;
  
  & > div:first-child {
    flex: 1 1 0;
    min-width: 0;
    max-width: calc(50% - 12px);
  }
    
  & > div:last-child {
    flex: 1 1 0;
    min-width: 0;
    max-width: calc(50% - 12px);
  }
  
  @media (max-width: 1056px) {
    & > div:first-child {
      flex: 1 1 0;
      min-width: 0;
      max-width: calc(50% - 12px);
    }
      
    & > div:last-child {
      flex: 1 1 0;
      min-width: 0;
      max-width: calc(50% - 12px);
    }
  }
`

const TestChatWrapper = styled.div`
   display: flex;
   flex: 1 1 auto;
   flex-direction: column;  
`
export {
  ViewPageWrapper,
  PlaygroundContainer,
  HeaderContainer,
  ContentWrapper,
  TestChatWrapper
}